import React from 'react';
import { Map, MapCircle, MapMarker } from '../../common/map';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class MountainPeakMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mapType: "naver",
      mountainPeaks: []
    };

    this.everestRepository = new EverestAdminRepository();
    this.onClickMapType.bind(this);
  }

  componentDidMount() {
    this.everestRepository.searchMountainPeak({}, (data) => {
      this.setState({ mountainPeaks: data.content });
    });
  }

  onClickMapType(e, mapType) {
    e.preventDefault();
    this.setState({ mapType });
  }

  render() {
    const markers = this.state.mountainPeaks.map(item => ({
      name: `${item.mountainName} ${item.peakName} (${item.height}m)`,
      position: [item.latitude, item.longitude]
    }));

    const circles = this.state.mountainPeaks.map(item => ({
      name: ``,
      center: [item.latitude, item.longitude],
      radius: 200,
      style: {
        strokeWeight: 1,
        strokeStyle: "solid",
        strokeColor: "#000",
        fillColor: "#f00",
        fillOpacity: 0.1
      }
    }));

    const footPrints =
      [[37.6592402835418, 127.0594108123115],
      [37.659181558625015, 127.0593884164584],
      [37.65895359223157, 127.05944719227243],
      [37.65632028041309, 127.06379479169682],
      [37.65633009254319, 127.06379805240047],
      [37.65634927506043, 127.06381664311053],
      [37.48112312316191, 126.95259847882018],
      [37.48110332521079, 126.95258959383132],
      [37.46720988575895, 126.94747420779812],
      [37.4687498105652, 126.94606997358035],
      [37.4687884492416, 126.94603381807127],
      [37.46717296450833, 126.94839077680915],
      [37.4532251377417, 126.94950740637726],
      [37.45322405904233, 126.94949109153067],
      [37.45188871476357, 126.94951056776429],
      [37.447726083256605, 126.9472145516669],
      [37.447390281507815, 126.9472810324209],
      [37.447371543971414, 126.94721151465629],
      [37.446064928919874, 126.95297645853485],
      [37.44508235497564, 126.95814166585156],
      [37.44283727100782, 126.96094587873216],
      [37.44210991356951, 126.96422849738788],
      [37.44211369150399, 126.96421290060105],
      [37.44487601192271, 126.9641368418067],
      [37.44505188704041, 126.96420780636714],
      [37.44505181240641, 126.96420950548148],
      [37.44505178213044, 126.96421009253847],
      [37.44300684021694, 126.96481737281574]];

    footPrints.map(item => ({
      name: ``,
      center: item,
      radius: 50,
      style: {
        strokeWeight: 1,
        strokeStyle: "solid",
        strokeColor: "#000",
        fillColor: "#00f",
        fillOpacity: 0.1
      }
    }));

    return (
      <React.Fragment>
        <NavigationBar />

        <Map mapType={this.state.mapType}>
          <MapMarker markers={markers || []} />
          <MapCircle circles={circles || []} />
        </Map>

        <div style={{ position: "absolute", top: 65, left: 10, padding: 10, background: "#fff", zIndex: 1 }}>
          <button className={`btn btn-sm btn-${this.state.mapType === "naver" ? "" : "outline-"}success`} onClick={(e) => this.onClickMapType(e, "naver")}>naver</button>&nbsp;
          <button className={`btn btn-sm btn-${this.state.mapType === "kakao" ? "" : "outline-"}warning`} onClick={(e) => this.onClickMapType(e, "kakao")}>kakao</button>&nbsp;
          <button className={`btn btn-sm btn-${this.state.mapType === "google" ? "" : "outline-"}primary`} onClick={(e) => this.onClickMapType(e, "google")}>google</button>
        </div>
      </React.Fragment>
    );
  }
}

export { MountainPeakMap };
